import { interactionModelActions } from './slice'

export const {
  addActivityGroup,
  removeActivityGroup,
  updateActivities,
  setGeolocation,
  getInteractionModel,
  setConfigToNewInteraction,
  setInitialConfiguration,
  setWorkflow
} = interactionModelActions

export default interactionModelActions
